import EntityPermissionsMapperBinder from "logic/permissions/EntityPermissionsMapper";
const supportedTypes = /* @__PURE__ */ new Set(["report"]);
const typePrefixCornerCasesMap = {
  report: "report:"
};
const reportEntityPermissionsMapper = {
  mapForIdAndType(_id, _type) {
    return void 0;
  },
  mapForType(type) {
    var _a;
    if (supportedTypes.has(type)) return (_a = typePrefixCornerCasesMap[type]) != null ? _a : `${type}s:`;
    return void 0;
  }
};
EntityPermissionsMapperBinder.register(reportEntityPermissionsMapper);
export default reportEntityPermissionsMapper;
